import { render, staticRenderFns } from "./group.vue?vue&type=template&id=4b21c79b&"
import script from "./group.vue?vue&type=script&lang=tsx&"
export * from "./group.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports